var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 38,
    viewBox: "0 0 88 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.300781 37.0523V10.9824H5.77358C7.94606 10.9824 9.82098 11.0518 11.6207 12.3993C13.494 13.7822 14.5067 16.0993 14.5067 18.2777C14.5067 20.5948 13.5692 22.3585 11.4719 23.6705C13.7948 24.7081 14.9562 27.4739 14.9562 29.7216C14.9562 34.8739 10.8336 37.0523 5.73678 37.0523H0.300781ZM5.88556 15.3038V21.6663C7.98445 21.6663 9.22107 20.3528 9.22107 18.381C9.22107 16.4092 8.02125 15.199 5.88556 15.3038ZM5.88556 25.6763V32.7295C8.13323 32.8328 9.44664 31.3126 9.44664 29.1328C9.44664 27.0931 8.09644 25.6054 5.88556 25.6748V25.6763Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8957 10.9824V27.8561C22.8957 29.8279 22.6349 32.8003 25.6697 32.8003C28.4069 32.8003 28.4069 30.8994 28.4437 28.9616V10.9824H34.0284V29.9991C34.0284 32.7649 33.6909 37.4685 25.6329 37.4685C20.424 37.4685 17.3125 35.2208 17.3125 30.3445V10.9824H22.8957Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2682 37.0518V10.9819H55.5028C56.477 10.9819 68.1713 9.66834 68.1713 24.2249C68.1713 31.6589 65.0598 37.0533 56.2515 37.0533H51.2666L51.2682 37.0518ZM62.5865 24.1895C62.5865 20.8703 61.4619 15.6132 56.853 15.6132V32.4175C61.3499 32.6256 62.5865 27.4379 62.5865 24.188V24.1895Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5164 10.9824V32.2129H82.362V37.0538H70.9316V10.9824H76.5164Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9051 11.0352V25.639L39.498 11.0352H45.9051Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.498 21.2734V37.1893L46.2411 37.052L39.498 21.2734Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3611 0.927734H70.958V5.93686H82.3611V16.4569H87.7907V5.93686V0.927734H82.3611Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavlogo);
export default __webpack_public_path__ + "static/media/Navlogo.54820f288ebc4f5fdb5a96312f1d848f.svg";
export { ForwardRef as ReactComponent };